import type { Storage } from '@shared/core';
import { getLocalStorage } from '@shared/core';
import { addError } from '@shared/utils/logger';
import { v1 as uuid } from 'uuid';

type AnalyticsId = ReturnType<Storage['getItem']>;
let cachedAnalyticsId: AnalyticsId;

/**
 * Get the stable analytics id stored in localStorage, generating if absent.
 */
export const getAnalyticsId = (): string => {
  if (cachedAnalyticsId) {
    return cachedAnalyticsId;
  }

  const storage = getLocalStorage();
  let existing: AnalyticsId;

  try {
    existing = storage.getItem('joy:analytics');
  } catch (error) {
    addError(error, { context: 'getAnalyticsId#getItemFailed' });
  }

  if (existing) {
    cachedAnalyticsId = existing;
    return cachedAnalyticsId;
  }

  const generated = uuid();

  try {
    storage.setItem('joy:analytics', generated);
  } catch (error) {
    addError(error, { context: 'getAnalyticsId#setItemFailed' });
  }

  cachedAnalyticsId = generated;
  return cachedAnalyticsId;
};
